module.exports = "@media only screen and (max-width: 768px) {\r\n\t\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/school/mobile.style.css
// module id = ./src/app/components/school/mobile.style.css
// module chunks = main